export default __webpack_public_path__ + "static/media/background.98394416.jpg";